import React from "react";
import InventoryJournalHeader from "../../components/Inventory/InventoryJournalHeader";
import { useTranslation } from "react-i18next";
const InventoryJournalEditPage: React.FC<{ params?: { [key: string]: any } }> = ({ params }) => {
    const { documentNo = "",documentType = 1,open = true } = params || {};
    const { t } = useTranslation();
    const parsedOpen = open === "false" ? false : open === "true" ? true : Boolean(open ?? true);
    return (
        <InventoryJournalHeader
            key={documentNo}
            documentNo={documentNo}
            documentType={documentType}
            readUrl={`/inventoryApi/GetInventoryJournal/?documentNo=${documentNo}&open=${parsedOpen}`}
            updateUrl="/inventoryApi/UpdateDocument"
            deleteUrl="taco"
            history={!parsedOpen}
            title={!parsedOpen ? t("common.journal") : t("common.editJournal")}
        />
    );
};

export default InventoryJournalEditPage;
